import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const DEFAULT_RECRUITMENT_LIST_BASE_ROUTE = '/recruitment-list';
export const useRecruitmentListNavigationItem = (): {
  id: string;
  icon: 'PlayerList';
  label: string;
  path: string;
} => {
  const {
    t,
    i18n: { language: locale },
  } = useTranslation('navigation');
  const { language } = useParams<{ language: string }>();
  const currentLocale = language || locale;
  const recruitmentListRoute = `/${currentLocale}${DEFAULT_RECRUITMENT_LIST_BASE_ROUTE}`;

  return {
    id: 'recruitment-list',
    icon: 'PlayerList' as const,
    label: t('primary.recruitmentList'),
    path: `${recruitmentListRoute}/overview`,
  };
};
